import {FC} from "react";
import {useTranslation} from "react-i18next";
import {LinkChip} from "@interstate/components/Chip";
import {ArrowTopRightOnSquareIcon} from "@interstate/components/Icons";
import {BadgeBar} from "../../badges";
import {useNavigation} from "../../navigation";
import {OperationalHierarchyNode} from "../backend";
import {EntitySourceType} from "../EntitySourceType";
import {HierarchyNodePopover} from "./HierarchyNodePopover";
import "./HierarchyNodeLabel.scss";

export interface HierarchyNodeLabelProps {
  node: OperationalHierarchyNode;
}

export const HierarchyNodeLabel: FC<HierarchyNodeLabelProps> = ({node}) => {
  const {t} = useTranslation();
  const {navigateToEntity} = useNavigation();
  const {organizationInformation} = node;

  return (
    <div
      id={`hierarchy-node-label-${node.id}`}
      data-testid={`hierarchy-node-label-${node.id}`}
      className={"hierarchy-node-label"}>
      <div className={"organization-info"}>
        <div className={"dba-name"}>{organizationInformation?.dbaName}</div>
        <div className={"address-line"}>
          {organizationInformation?.address?.streetAddressLine1 +
            ", " +
            (organizationInformation?.address?.streetAddressLine2
              ? organizationInformation?.address?.streetAddressLine2 + ", "
              : "") +
            organizationInformation?.address?.city +
            ", " +
            organizationInformation?.address?.state}
        </div>
      </div>
      <BadgeBar
        onClick={(event: Event) => {
          event.stopPropagation();
        }}>
        <HierarchyNodePopover node={node}>
          <LinkChip
            data-testid={`operational-overview-link-${node.id}`}
            icon={<ArrowTopRightOnSquareIcon />}
            iconPosition={"left"}
            label={t("entity-detail.hierarchy-view.overview-link")}
            onClick={(event: Event) => {
              event.stopPropagation();
              navigateToEntity(node.id, EntitySourceType.OPERATIONAL);
            }}
          />
        </HierarchyNodePopover>
      </BadgeBar>
    </div>
  );
};
